class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

setupEventListeners() {
  let allSearchForms = [];
  this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
  this.input.addEventListener('focus', this.onInputFocus.bind(this));
  if (allSearchForms.length < 2) return;
  allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
  this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));

  // 初始化：给所有搜索表单加上 type=product
  allSearchForms.forEach((form) => {
    if (form && !form.querySelector('input[name="type"][data-search-type]')) {
      const typeInput = document.createElement('input');
      typeInput.type = 'hidden';
      typeInput.name = 'type';
      typeInput.value = 'product';
      typeInput.dataset.searchType = '1';
      form.appendChild(typeInput);
    }
  });
}

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

keepInSync(value, target) {
  this.allSearchInputs.forEach((input) => {
    if (input !== target) {
      input.value = value;
    }
    // 确保每个搜索表单都有 type=product 的 hidden input
    const form = input.form;
    if (form && !form.querySelector('input[name="type"][data-search-type]')) {
      const typeInput = document.createElement('input');
      typeInput.type = 'hidden';
      typeInput.name = 'type';
      typeInput.value = 'product';
      typeInput.dataset.searchType = '1';
      form.appendChild(typeInput);
    }
  });
}
}

customElements.define('main-search', MainSearch);
